<script>
import dayjs from '@/services/date'
import DateFormatToken from '@/shared/constants/date/DateFormatToken'
import { mapEducatorType } from '../../../helpers/candidate-details-helpers'
import CandidateDetailItem from './candidate-detail-item.vue'

export default {
  name: 'CandidateDetailItems',
  components: { CandidateDetailItem },
  props: {
    candidate: {
      type: Object,
      default: null,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    fullName() {
      return this.candidate?.fullName || null
    },
    dob() {
      const date = this.candidate?.dob
      if (!date) return null
      return dayjs(date)
        .locale(this.$i18n.locale.toLowerCase())
        .format(DateFormatToken.LL)
    },
    types() {
      return (this.candidate?.types ?? []).map((t) => mapEducatorType(t.title))
    },
    location() {
      return this.candidate?.location || null
    },
    detailItems() {
      return [
        {
          label: this.$t('candidateDetailsPopup.details.fullName'),
          value: this.fullName?.toLowerCase(),
          icon: 'mdi-account-outline',
          hidden: !this.fullName,
        },
        {
          label: this.$t('candidateDetailsPopup.details.dob'),
          value: this.dob,
          icon: 'mdi-calendar-month-outline',
          hidden: !this.dob,
        },
        {
          label: this.$t('candidateDetailsPopup.details.types'),
          value: this.types.join(', '),
          icon: 'mdi-briefcase-outline',
          hidden: this.types.length === 0,
        },
        {
          label: this.$t('candidateDetailsPopup.details.location'),
          value: this.location?.toLowerCase(),
          icon: 'mdi-map-marker-outline',
          hidden: !this.location,
        },
      ].filter(({ hidden }) => !hidden)
    },
  },
}
</script>

<template>
  <div class="candidate-detail-items">
    <!-- Skeleton rows while loading -->
    <template v-if="isLoading">
      <div
        v-for="width in ['160px', '120px', '200px', '140px']"
        :key="width"
        class="d-flex align-start mb-2"
      >
        <div class="flex-shrink-0" style="width: 200px">
          <v-skeleton-loader
            loading
            type="image"
            style="width: 140px; height: 16px;"
          />
        </div>
        <v-skeleton-loader
          loading
          type="image"
          :style="`width: ${width}; height: 16px;`"
        />
      </div>
    </template>

    <template v-else>
      <CandidateDetailItem
        v-for="item in detailItems"
        :key="item.label"
        :icon="item.icon"
        :label="item.label"
      >
        <div
          v-if="item.label === $t('candidateDetailsPopup.details.types')"
          class="text-md"
          >{{ item.value }}</div
        >
        <span v-else class="text-md text-capitalize">{{ item.value }}</span>
      </CandidateDetailItem>
    </template>
  </div>
</template>
